import headerComponent from '@/components/cust_components/cust_header_component.vue';
import axios from 'axios';

export default {
    name: 'login',
    components:{
        headerComponent,
    
    },
    data(){
        return {
            mobile_view : false,
            cust_email:'',
            email_validation:'',
            all_validations_passed: false,
            isClicked: false
        }
    },
    mounted(){
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
    },
    methods:{
        async responsive_view(){

            await this.$store.commit('responsive_view', window.innerWidth)
           
        },
        login(){
            this.$router.push('/custlogin')
        },
        check_email_validation(){

            this.email_validation = ''; 
            if(this.cust_email.length == 0){
                this.all_validations_passed = false
                this.email_validation = 'Please enter valid email'
            }
    
            else if(!this.$store.state.regx.test(this.cust_email)) {  
                this.all_validations_passed = false
                this.email_validation = 'Invalid email address' 
                
            }

           
        },
        validation_check(){
            this.all_validations_passed = true;
            this.check_email_validation();
        },
        submit(){
            this.validation_check();
            if(this.all_validations_passed){
                this.isClicked = true;
                axios.post(this.$store.state.api + `v2/customer/forgot_password_v2`, {
                    "cust_email": this.cust_email,
                }).then(response => {
                    this.isClicked = false;
                    if (response.status === 200) {
                        this.$router.push('/mailsent');
                    }
                }).catch(error => {  
                    this.isClicked = false;
                    if (error.response.status === 400) {    
                    this.email_validation = "This email is not registered with us.";
                    }
                }) 
            }
            

        },

    }
}